"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateColorBuffer = void 0;
const color_normalize_1 = __importDefault(require("color-normalize"));
function isSingleColor(input) {
    return !Array.isArray(input) || !Array.isArray(input[0]);
}
function updateColorBuffer(colorBuffer, colorData, colors, count) {
    if (isSingleColor(colors)) {
        let c = color_normalize_1.default(colors, "uint8");
        for (let i = 0; i < count + 1; i++) {
            colorData.set(c, i * 4);
        }
    }
    else {
        for (let i = 0; i < count; i++) {
            let c = color_normalize_1.default(colors[i], "uint8");
            colorData.set(c, i * 4);
        }
        colorData.set(color_normalize_1.default(colors[0], "uint8"), count * 4);
    }
    colorBuffer.subdata(colorData);
}
exports.updateColorBuffer = updateColorBuffer;
